module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////yy6755tnljjjqpm3srnv12cT9+fb338/onl3nlkvtton67OP00rnvvZbxxKL88+wo1o2bAAAApklEQVR4Ae2SRQLEIAxFCR+3cv/LjqarIRnf9W0qD4mZg/9CjF1rMCRp56+EpbUAHyvpqOgEUEapwhEEJknahdaBstSBBq9SIxR0tOF2iKAzcPExA1E4FdkXYFMzq1JxZieiZv7ADHaHhMB31trfcJLmF0nTjSFp5rPdWbubkLXdpN/t4ZXdEQjK3QRMWbcCf3OUxmKSN6DxVmA8Hj46R+h9neYbDs5IHQRsvmD8YgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_may.png
// module id = 1692
// module chunks = 1